import carbonCloud from '@/assets/images/carbon-simulation/carbon-cloud.png'

interface BiomassAndCarbonProps {
  totalBiomass: string
  abovegroundBiomass: string
  belowGroundBiomass: string
  totalCo2Equivalent: string
  totalCarbonStock: string
  abovegroundCarbonStock: string
  belowGroundCarbonStock: string
}

export function BiomassAndCarbon({
  totalBiomass,
  abovegroundBiomass,
  belowGroundBiomass,
  totalCo2Equivalent,
  abovegroundCarbonStock,
  belowGroundCarbonStock,
  totalCarbonStock,
}: BiomassAndCarbonProps) {
  return (
    <div className="order-3 col-span-6 flex h-full w-full flex-col justify-center gap-20 rounded-2xl bg-bios-yellow-100 px-8 py-12 text-center shadow-2xl lg:order-2 lg:col-span-4">
      <h1 className="text-center text-3xl font-bold text-bios-green-1050">
        Distribuição de estoque de biomassa e carbono
      </h1>

      <div className="flex flex-col justify-around gap-10 *:flex *:flex-col *:items-center *:gap-6 lg:flex-row lg:items-center 2xl:gap-20">
        {/* SESSÃO 1 */}

        <div>
          <div className="relative flex size-48 items-center justify-center 2xl:size-52">
            <div
              className="absolute inset-0 rounded-full"
              style={{
                background:
                  'conic-gradient(#079521 5%, #02562D 55%, #03FF81 0%, #6DE243 100%)',
              }}
            />

            <div className="relative flex size-28 flex-col items-center justify-center rounded-full bg-bios-yellow-100 2xl:size-32">
              <p className="text-lg font-semibold text-monochromatic-500">
                Total
              </p>
              <span className="text-2xl font-bold text-bios-primary 2xl:text-4xl">
                {totalBiomass}
              </span>
              <p className="text-lg text-monochromatic-500">tMS/ha</p>
            </div>
          </div>

          <div className="flex flex-col gap-8 lg:max-w-48">
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <div className="size-4 rounded-full bg-bios-darkGreen-400 p-2" />

                <p className="text-start text-lg font-bold text-bios-green-1050">
                  Biomassa acima do solo (AGB)
                </p>
              </div>

              <p className="ml-6 flex items-center gap-1 text-start text-xl text-monochromatic-500">
                <strong className="text-3xl text-bios-primary">
                  {abovegroundBiomass}
                </strong>
                tMS/ha
              </p>
            </div>

            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <div className="size-4 rounded-full bg-bios-green-600 p-2" />

                <p className="text-start text-lg font-bold text-bios-green-1050">
                  Biomassa abaixo do solo (BGB)
                </p>
              </div>

              <p className="ml-6 flex items-center gap-1 text-start text-xl text-monochromatic-500">
                <strong className="text-3xl text-bios-primary">
                  {belowGroundBiomass}
                </strong>
                tMS/ha
              </p>
            </div>
          </div>
        </div>

        {/* SESSÃO 2 */}

        <div className="lg:gap-16!">
          <img
            className="2xl:w-60"
            src={carbonCloud}
            alt="Imagem de nuvem carbono"
          />

          <div>
            <div className="flex max-w-72 flex-col gap-4 rounded-3xl bg-linear-to-b from-bios-green-1050 to-bios-green-900 p-6 text-white">
              <p className="text-lg font-semibold">
                Estoque total equivalente de CO₂
              </p>

              <div>
                <p className="text-4xl font-bold text-bios-lime-600">
                  {totalCo2Equivalent}
                </p>
                <p>tCO₂e/ha</p>
              </div>
            </div>
          </div>
        </div>

        {/* SESSÃO 3 */}

        <div>
          <div className="relative flex size-48 items-center justify-center 2xl:size-52">
            <div
              className="absolute inset-0 rounded-full"
              style={{
                background:
                  'conic-gradient(#98DD29, #66FF00 75%, #06671B 0%, #31971F 100%)',
              }}
            />

            <div className="relative flex size-28 flex-col items-center justify-center rounded-full bg-bios-yellow-100 2xl:size-32">
              <p className="text-lg font-semibold text-monochromatic-500">
                Total
              </p>
              <span className="text-2xl font-bold text-bios-primary 2xl:text-4xl">
                {totalCarbonStock}
              </span>
              <p className="text-lg text-monochromatic-500">tC/ha</p>
            </div>
          </div>

          <div className="flex flex-col gap-8 lg:max-w-48">
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <div className="size-4 rounded-full bg-bios-green-700 p-2" />

                <p className="text-start text-lg font-bold text-bios-green-1050">
                  Estoque de carbono acima do solo
                </p>
              </div>

              <p className="ml-6 flex items-center gap-1 text-start text-xl text-monochromatic-500">
                <strong className="text-3xl text-bios-primary">
                  {abovegroundCarbonStock}
                </strong>
                tC/ha
              </p>
            </div>

            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <div className="size-4 rounded-full bg-bios-lime-100 p-2" />

                <p className="text-start text-lg font-bold text-bios-green-1050">
                  Estoque de carbono abaixo do solo
                </p>
              </div>

              <p className="ml-6 flex items-center gap-1 text-start text-xl text-monochromatic-500">
                <strong className="text-3xl text-bios-primary">
                  {belowGroundCarbonStock}
                </strong>
                tC/ha
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
